import { Footer } from '~shared/ui/footer';
import { Screen, ScreenHeader } from '~shared/ui/screen';

import { Storefront as StorefrontIllustration } from '@breezeventures/ui-kit/next/illustrations/medium/storefront';
import { Typography } from '@breezeventures/ui-kit/typography';

type AgentsStartProps = {
  onBack: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const AgentsStart = ({
  onBack,
  onClose,
  onSubmit,
}: AgentsStartProps) => {
  return (
    <Screen
      header={<ScreenHeader onBack={onBack} onClose={onClose} />}
      footer={<Footer submitButtonText="Start adding" onSubmit={onSubmit} />}
    >
      <div className="my-auto flex flex-col items-center">
        <StorefrontIllustration alt="" />

        <div className="mt-8 flex flex-col items-center gap-3 text-center">
          <Typography.Title size="s">Add your sales agents</Typography.Title>
          <Typography.Text size="m" color="secondary">
            Fill&nbsp;in the&nbsp;details for each sales agent and
            their&nbsp;assigned&nbsp;store. They&nbsp;will&nbsp;assist customers
            in&nbsp;applying&nbsp;for&nbsp;Skyro&nbsp;loans.
          </Typography.Text>
        </div>
      </div>
    </Screen>
  );
};
